export default {
	data(){
		return {
			beneficiariosItems: [
				{
					thead: {th: "Documento"},
					tbody: {td: ["id_list_documento","documento"], col: [4,8] }
				},
				{
					thead: {th: "Nombres"},
					tbody: {td: ["name"] }
				},
				{
					thead: {th: "Servicios", style: "width: 130px"},
					tbody: {td: ["servicios"] }
				},
				{
					thead: {th: "F. nacimiento"},
					tbody: {td: ["nacimiento"] }
				},
			],
			beneficiariosInits: [],
			
		}
	},
}